export default "__VITE_ASSET__aa317f3d__"